var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5853 2.86593L17.1341 3.41483C17.368 3.64855 17.4996 3.96564 17.4999 4.29638V4.92844C17.5041 5.26494 17.3721 5.58884 17.1341 5.82663L15.5959 7.34024C15.5179 7.41896 15.4116 7.46324 15.3008 7.46324C15.1899 7.46324 15.0837 7.41896 15.0056 7.34024L12.6693 4.97002C12.5109 4.80833 12.5109 4.54956 12.6693 4.38786L14.1742 2.86593C14.4119 2.6278 14.7357 2.49584 15.0721 2.5H15.704C16.0347 2.5003 16.3517 2.63192 16.5853 2.86593ZM14.0162 8.90376C14.1747 8.74206 14.1747 8.48329 14.0162 8.3216L11.6383 5.97633C11.5603 5.8976 11.454 5.85332 11.3432 5.85332C11.2323 5.85332 11.1261 5.8976 11.048 5.97633L4.3384 12.6878C4.17619 12.8486 4.04883 13.0411 3.96426 13.2533L2.5342 16.8627C2.4532 17.0501 2.52013 17.2685 2.69218 17.3783C2.81001 17.496 2.98668 17.532 3.14115 17.4698L6.74954 16.0061C6.96169 15.9215 7.15415 15.7941 7.31491 15.6319L14.0162 8.90376Z",
    fill: "#4D546E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.e2ee4717e297f5bdad9f0001c0e258e2.svg";
export { ForwardRef as ReactComponent };